import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import type { SourceQuery } from '../../entities/useSourceQuery';

/** Says where the screen's data comes from: Fides (admin API) or the prototype's sample data. */
export default function SourceNotice({ sample }: { sample?: boolean }) {
  return sample ? (
    <Alert severity="warning" sx={{ mb: 2 }}>
      Sample data: fictional entities and allocations shaped like the Fides admin API. Signed in to
      the registry console, this screen reads the real ones.
    </Alert>
  ) : (
    <Alert severity="success" sx={{ mb: 2 }}>
      Live from Fides: investment entities, linked contacts and allocations as recorded in the admin
      portal (read only).
    </Alert>
  );
}

/** Loading spinner or error for a query; renders children once data has arrived. */
export function QueryStatus<T>({
  query,
  children,
}: {
  query: SourceQuery<T>;
  children: (data: T) => React.ReactNode;
}) {
  if (query.error) return <Alert severity="error">{query.error}</Alert>;
  if (query.loading || query.data === null)
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 4 }} role="status">
        <CircularProgress size={20} />
        <Typography variant="body2" color="text.secondary">
          Loading…
        </Typography>
      </Box>
    );
  return <>{children(query.data)}</>;
}
